import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './Spinner.module.scss';

const size = (small, banner) => {
    if (small) return s.ldsRingSmall;
    if (banner) return s.ldsRingBanner;

    return s.ldsRing;
};

const Spinner = ({ 'data-testid': dataTestId, loading = false, small, banner, mapView, poiSheetShowing, className, color = null }) => {
    const circleSize = size(small, banner);
    if (loading) {
        return (
            <div 
                data-testid={`${dataTestId}-spinner`} 
                className={classNames(circleSize, { [s.mapView]: mapView, [s.poiSheetShowing]: poiSheetShowing }, className)}
                style={{ '--spinner-color': color }}
                >
                <div />
                <div />
                <div />
            </div>
        );
    } else {
        return <div />;
    }
};
Spinner.propTypes = { loading: PropTypes.bool };

export default Spinner;
